import { useEffect } from 'react';

import {
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  Skeleton,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface InputFormSelectProps {
  fullWidth?: boolean;
  sx?: object;
  label: string;
  children: any | Element[];
  defaultValue?: string;
  name: string;
  control: Control<any, object>;
  isLoading?: boolean;
  hasError?: boolean;
  visible?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange?: (event: SelectChangeEvent<any>) => void;
  disabled?: boolean;
}
function InputFormSelect({
  fullWidth,
  sx,
  label,
  children,
  defaultValue,
  name,
  control,
  isLoading,
  hasError,
  visible = true,
  onChange,
  disabled,
}: InputFormSelectProps) {
  useEffect(() => {}, [isLoading, visible]);

  if (isLoading) {
    return <Skeleton sx={sx} variant="rectangular" width="100%" height="5.665rem" />;
  }
  const labelId = `${name}-label`;
  return (
    <FormControl
      fullWidth={fullWidth}
      sx={{
        ...sx,
        visibility: visible ? 'visible' : 'hidden',
        display: visible ? 'inline-flex' : 'none',
      }}
    >
      <InputLabel id={labelId}>{ label }</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            labelId={labelId}
            label={label}
            {...field}
            error={hasError}
            onChange={(event: SelectChangeEvent<string>) => {
              field.onChange(event);
              if (onChange) onChange(event);
            }}
            disabled={disabled}
          >
            { children }
          </Select>
        )}
        defaultValue={defaultValue || ''}
      />
    </FormControl>
  );
}

export default InputFormSelect;
